module.exports = __webpack_public_path__ + "img/home-keys.4e75b9b3.svg";